import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { sendCustomEmailTemplate, CustomEmailTemplateParameter } from "../../Services/EmailService";

export type SubmitCustomEmailFormParameter = {
    templateData: CustomEmailTemplateParameter;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<SubmitCustomEmailFormParameter, CustomEmailTemplateParameter>;

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter.templateData;
};

export const SendDataToApi: HandlerType = async props => {
    await sendCustomEmailTemplate(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const submitCustomEmailForm = createHandlerChainRunner(chain, "SubmitCustomEmailForm");
export default submitCustomEmailForm;
